import { render, staticRenderFns } from "./FactCard.vue?vue&type=template&id=5d7661ac&scoped=true&"
import script from "./FactCard.vue?vue&type=script&lang=js&"
export * from "./FactCard.vue?vue&type=script&lang=js&"
import style0 from "./FactCard.vue?vue&type=style&index=0&id=5d7661ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7661ac",
  null
  
)

export default component.exports